
const initialState = {
  original: {},
  center: {
    lat: 37.774929,
    lng: -122.419416
  },
  zoom: 5,
  currentLocation: null, //NOTE only for preloading browser "Current Location"
  origin: null,
  destination: null,
  waypoints: [],
  polylinePath: [],
  directions: null,
  markers: [null, null],
  // bounds: null,
  fromLatLng: null,
  toLatLng: null,
}

function reducer(state=initialState, action) {
  switch (action.type) {

// INITIALIZE:
    case 'RESET_INITIAL_MAP_STATE':
    case 'GET_TRIP_REQUEST':
      return initialState

    // case 'GET_TRIP_SUCCESS':
    // case 'REPOPULATE_FROM_TRIP':
    // TODO can we set one "from" with either start_place, from or started_at_coordinate?
    // TODO separate out SET_BOUNDS
    case 'POPULATE_MAP':
      const payload = action.payload || state.original
      const startedAtCoord = formatLatLng(payload.started_at_coordinate)
      const endedAtCoord = formatLatLng(payload.ended_at_coordinate)
      // const origin = startedAtCoord
      // const destination = endedAtCoord
      return {
        ...state,
        // origin,
        // destination,
        polylinePath: formatWaypointsToPolyline(payload.locations),
        markers: [
          // origin,
          // destination,
          startedAtCoord,
          endedAtCoord
        ],
        original: payload
      }
    case 'SET_ORIGIN':
      return {
        ...state,
        origin: action.origin
      }
    case 'SET_DESTINATION':
      return {
        ...state,
        destination: action.destination
      }
    // case 'SET_TO_LAT_LNG':
    //   return {
    //     ...state,
    //     toLatLng: action.latLng
    //   }
    // case 'SET_FROM_LAT_LNG':
    //   return {
    //     ...state,
    //     fromLatLng: action.latLng
    //   }
// // ROUND TRIP:
//     case 'ENABLE_ROUND_TRIP':
//       return {
//         ...state,
//         destination: state.origin,
//         waypoints: [
//           // ...state.waypoints,
//           {location: state.destination}
//         ]
//       }
//     case 'DISABLE_ROUND_TRIP':
//       return {
//         ...state,
//         waypoints: [],//state.waypoints.slice(1),
//         // destination: state.waypoints[state.waypoints.length-1].location,
//         // destination: {lat:state.original.end_place.latitude, lng:state.original.end_place.longitude}
//         destination: state.toLatLng
//       }

// GOOGLE MAPS DIRECTIONS SERVICE:
    case 'RECEIVE_DIRECTIONS':
    case 'REJECT_DIRECTIONS':
      return {
        ...state,
        directions: action.response
      }

    case 'CLEAR_DIRECTIONS':
      return {
        ...state,
        directions: null
      }

    case 'CLEAR_MAP':
      return {
        ...state,
        polylinePath: [],
        markers: [null, null]
      }

    // case 'DIRECTIONS_CHANGED':
    //   const {overview_path} = action.directions.routes[0]
    //   // const waypoints = action.directions.geocoded_waypoints
    //   return {
    //     ...state,
    //     origin: overview_path[0],
    //     destination: overview_path[overview_path.length-1],
    //   }

    // case 'SET_CURRENT_POSITION':
    //   return {
    //     ...state,
    //     [action.label]: {lat: action.latitude, lng: action.longitude}
    //   }

    case 'SELECT_FROM':
      return {
        ...state,
        origin: action.origin,
        markers: [
          action.origin,
          state.markers[1] || null,
        ],
        zoom: 13,
        center: action.origin,
        // fromLatLng: action.origin
      }

    case 'SELECT_TO':
      return {
        ...state,
        destination: action.destination,
        markers: [
          state.markers[0] || null,
          action.destination,
        ],
        zoom: 13,
        center: action.destination,
        // toLatLng: action.destination
      }

    default:
      return state
  }
}

export const formatWaypointsToPolyline = (waypoints) => waypoints ? waypoints.map(w=> ( {lat: +w.split(',')[0], lng: +w.split(',')[1]} )) : []
// export const formatLatLng = (str) => ({lat: +str.split(',')[0], lng: +str.split(',')[1]})
export const formatLatLng = (str) => {
  if (str) {
    return {lat: +str.split(',')[0], lng: +str.split(',')[1]}
  } else {
    return {}
  }
}


export default reducer



// WEBPACK FOOTER //
// ./src/map/reducer.js